import angular from 'angular';

import InventoryTabsComponent from './inventory-tabs-component';

export default angular.module('inventory-tabs', []).component('inventoryTabs', new InventoryTabsComponent());



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-tabs/inventory-tabs-module.js